import ReactPDF, { pdf } from "@react-pdf/renderer";
import { useFileDownloader } from "@Utils";

interface IUseDownload {
    // TODO: find out why this is a function
    file: () => React.ReactElement<ReactPDF.DocumentProps>;
    fileName: string;
}

const usePDFDownload = () => {
    const { downloadFile } = useFileDownloader();

    const download = async ({ file, fileName }: IUseDownload): Promise<boolean | never> => {
        const reportBlob = pdf(file()).toBlob();

        return await reportBlob.then((blob: Blob) => {
            return downloadFile(blob, fileName);
        });
    };

    return download;
};

export default usePDFDownload;
